import React from 'react';
import dashPreview from '../assets/dashPreview.png'; // exemple
import checkList from '../assets/checkList.png';

const HowItWorks = () => {
  return (
    <section className="py-10 px-4 bg-blue-50 text-gray-800">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold mb-6">Comment ça marche&nbsp;?</h1>

        <p className="mb-4">
          Avec myPlum+, vous suivez un parcours simple et guidé pour compléter
          votre dossier, comprendre vos droits et déposer les bons documents.
        </p>

        {/* Etapes */}
        <div className="space-y-8">
          <div className="bg-white p-6 rounded-lg shadow flex flex-col md:flex-row items-center gap-4">
            <img src={dashPreview} alt="Aperçu du dashboard" className="w-full md:w-1/2 rounded-md"/>
            <div className="md:w-1/2">
              <h2 className="text-xl font-semibold mb-2">Étape 1 : Inscription & questionnaire</h2>
              <p className="text-sm">
                Créez votre compte en quelques clics. Répondez à un court
                questionnaire pour personnaliser votre tableau de bord
                (enfants, situation financière, etc.).
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow flex flex-col md:flex-row items-center gap-4">
            <div className="md:w-1/2 order-2 md:order-1">
              <h2 className="text-xl font-semibold mb-2">Étape 2 : Check-lists & documents</h2>
              <p className="text-sm">
                Accédez à vos check-lists (formulaires, pièces justificatives). 
                myPlum+ vous indique quoi faire dans quel ordre, pour éviter
                tout “dossier incomplet”.
              </p>
            </div>
            <img src={checkList} alt="Check-list" className="w-full md:w-1/2 order-1 md:order-2 rounded-md"/>
          </div>

          <div className="bg-white p-6 rounded-lg shadow flex flex-col md:flex-row items-center gap-4">
            <img src={dashPreview} alt="Timeline" className="w-full md:w-1/2 rounded-md"/>
            <div className="md:w-1/2">
              <h2 className="text-xl font-semibold mb-2">Étape 3 : Timeline & support</h2>
              <p className="text-sm">
                Suivez votre progression via notre frise graphique. 
                Besoin d’aide&nbsp;? Posez votre question par email, 
                vous recevez une réponse en moins de 48h (24h si PRO).
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="#tarifs"
            className="inline-block bg-warning text-white px-6 py-3 rounded-full text-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
          >
            Voir nos formules
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
